export default "__VITE_ASSET__BM78K7zu__"